var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloseFilter = function SvgCloseFilter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46316 5.67128L11.7989 1.20104C12.0654 0.926274 12.0662 0.480546 11.8001 0.206155C11.5321 -0.0701495 11.1019 -0.0676887 10.8351 0.207378L6.4994 4.67762L2.16368 0.207378C1.89718 -0.0673856 1.46487 -0.0682365 1.19873 0.206155C0.930741 0.482459 0.933127 0.92597 1.19992 1.20104L5.53564 5.67128L1.19992 10.1415C0.933421 10.4163 0.932596 10.862 1.19873 11.1364C1.46672 11.4127 1.89689 11.4102 2.16368 11.1352L6.4994 6.66494L10.8351 11.1352C11.1016 11.4099 11.5339 11.4108 11.8001 11.1364C12.0681 10.8601 12.0657 10.4166 11.7989 10.1415L7.46316 5.67128Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloseFilter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/CloseFilter.20643f64.svg";
export { ForwardRef as ReactComponent };